module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lookindex paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("更多就诊信息")]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": _vm.typetitle,
      "value": _vm.typevalue
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-jiuzhen",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "就诊记录",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.link('http://app.cdxt.com.cn/scvif/pages/myMedicalRecord.html')
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-jilu",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "检查报告",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.link('http://app.cdxt.com.cn/scvif/pages/checkReports.html')
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-jianchajieguo",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "检验报告",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.link('http://app.cdxt.com.cn/scvif/pages/examineReports.html')
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-jianyan",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_vm._v("超药品说明书同意书")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.lookArry), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.lookArry.length != 0),
        expression: "lookArry.length !=0"
      }]
    }, [_c('td', [_vm._v(_vm._s(item.CREATED_DATE))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.TITLE))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": 'data:image/gif;base64,' + item.KEY_PIC
      }
    })])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lookArry.length == 0),
      expression: "lookArry.length == 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("暂无数据！")])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "23%"
    }
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "52%"
    }
  }, [_vm._v("同意书名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("医生签名")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9891248","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/internetHospital/lookIndex.vue
// module id = Cdcl
// module chunks = 7